import React from 'react';

export const getProviderIcon = (type: string | undefined) => {
  switch (type?.toLowerCase()) {
    case 'cloudflare':
      return '🔶';
    case 'route53':
    case 'aws':
      return '🟠';
    case 'azure':
      return '🔵';
    case 'gcp':
    case 'google':
      return '🟢';
    case 'digitalocean':
      return '🌊';
    default:
      return '🛡️';
  }
};

export const getStatusBadge = (status?: string) => {
  switch (status?.toLowerCase()) {
    case 'active':
      return (
        <div className="inline-flex items-center px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 rounded-full text-xs font-medium">
          <div className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1"></div>
          Active
        </div>
      );
    case 'inactive':
      return (
        <div className="inline-flex items-center px-2 py-1 bg-gray-100 dark:bg-gray-900/30 text-gray-700 dark:text-gray-400 rounded-full text-xs font-medium">
          <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mr-1"></div>
          Inactive
        </div>
      );
    case 'pending':
      return (
        <div className="inline-flex items-center px-2 py-1 bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 rounded-full text-xs font-medium">
          <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full mr-1"></div>
          Pending
        </div>
      );
    default:
      return (
        <div className="inline-flex items-center px-2 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 rounded-full text-xs font-medium">
          <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-1"></div>
          Unknown
        </div>
      );
  }
};